/**
 * Single source of truth for identity, links and assets.
 * Anything that appears in more than one place on the site lives here.
 */

export const site = {
  name: "Chafic Achour",
  // The arrow motif ("Backend Engineer -> AI Systems") is the compact identity
  // line used on the about page. The home hero gets the full claim below,
  // because an arrow reads as "heading somewhere" and the first screen needs
  // to say what is already true.
  role: "Backend Engineer",
  focus: "AI Systems",
  // Hero. Kept to two lines at every width; `textWrap: balance` does the rest.
  headline: "Backend engineer building AI systems",
  tagline:
    "I build LLM applications, RAG systems and AI agents on top of production Spring Boot microservices.",
  location: "Lebanon",
  email: "chafic.achour12@gmail.com",
  url: "https://www.chafic-achour.com",
  // Used for the home page <title> and as the default meta description.
  // Keep in sync with the same tags in public/index.html, which is what social
  // and search crawlers read (they do not run the JS that sets these).
  metaTitle: "Chafic Achour - Backend Engineer Building AI Systems",
  description:
    "Backend engineer in Lebanon building LLM applications, RAG systems and AI agents on top of production Spring Boot microservices.",
};

/**
 * The hero's proof strip. Numbers carry more weight on a first screen than
 * adjectives do, so the claim above is immediately grounded in results that
 * came out of real production work.
 *
 * Every figure here must be traceable to data/experience.js. If one changes
 * there, change it here.
 */
export const proofPoints = [
  { value: "29%", label: "lower response latency" },
  { value: "31%", label: "higher test coverage" },
  { value: "4", label: "Gulf markets in production" },
];

/**
 * Contact page copy. The left column was a heading, three lines and then 300px
 * of nothing; these are the things someone deciding whether to write actually
 * wants to know before they do.
 */
export const contact = {
  title: "Get in touch",
  intro:
    "Whether it is a role, a freelance build, or a question about something here, send it over and I will get back to you.",
  facts: [
    { label: "Based in", value: "Beirut, Lebanon (GMT+3)" },
    { label: "Open to", value: "AI and backend engineering roles, and freelance work" },
    { label: "Reply time", value: "Usually within a day" },
  ],
};

export const socials = [
  { label: "GitHub", href: "https://github.com/Chafic123/", icon: "github" },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/chafic-achour",
    icon: "linkedin",
  },
  { label: "Email", href: `mailto:${site.email}`, icon: "email" },
];

export const assets = {
  heroAvatar: "/chafic-hero.webp",
  aboutAvatar: "/chafic-about.webp",
  openToWork: "/open-to-work.webp",
  cv: {
    // Kebab-case to match the other public assets, and because a space in the
    // path has to survive URL encoding on every link that points at it.
    href: "/chafic-achour-cv.pdf",
    downloadAs: "Chafic_Achour_CV.pdf",
  },
};

export const navItems = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Projects", path: "/projects" },
  { label: "Contact", path: "/contact" },
];
